import { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Loads from './Loads';
import AssetLoads from './AssetLoads';
import { projectStore } from '../../store/Store';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function LoadTabs({setLoadLockTrigger, setIsAsset, setLockEndpoint}) {
  // global
  const projectLoads = projectStore(data => data.projectLoads)
  const projectAssetLoads = projectStore(data => data.projectAssetLoads)
  // local
  const [value, setValue] = useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', margin: '20px 0 0 0' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {projectLoads && <Tab label="Freight Loads" {...a11yProps(1)} sx={{fontWeight: 'bold', fontSize: '1rem'}}/>}
          {projectAssetLoads && <Tab label="Asset Loads" {...a11yProps(0)} sx={{fontWeight: 'bold', fontSize: '1rem'}}/>}
        </Tabs>
      </Box>
      {projectLoads && <CustomTabPanel value={value} index={0}>
        <Loads setLoadLockTrigger={setLoadLockTrigger} setIsAsset={setIsAsset} setLockEndpoint={setLockEndpoint}/>
      </CustomTabPanel>}
      {projectAssetLoads &&<CustomTabPanel value={value} index={1}>
        <AssetLoads setLoadLockTrigger={setLoadLockTrigger} setIsAsset={setIsAsset} setLockEndpoint={setLockEndpoint}/>
      </CustomTabPanel>}
    </Box>
  );
}